<template>
  <footer class="footer">
    <div class="footer-top">
      <div class="footer-top-main">
        <p>
          <span>友情链接：</span>
          <template v-for="item in tableData">
            <a v-bind:href="item.Ljurl" target="_blank" v-bind:key="item.ID">{{item.Dwmc}}</a>
          </template>
        </p>
      </div>
    </div>
    <div class="footer-bot">
      <div class="footer-bot-main clearfix">
        <div class="footer-main-left">
          <ul class="clearfix">
            <li><a href="http://www.crecu.com/" target="_blank" style="color:white;">主办单位：自然资源部煤炭资源勘查与综合利用重点实验室</a></li>
            <li><a href="http://www.longruan.com/" target="_blank" style="color:white;">技术支持：北京龙软科技股份有限公司</a></li>
            <li>
              联系我们：中国·陕西·西安市未央区文景路26号A陕煤地质科研办公楼
            </li>
            <li><a href="http://beian.miit.gov.cn" target="_blank" style="color:white;">网站备案号：陕ICP备05015530号-2</a></li>
          </ul>
        </div>
        <div class="footer-main-right fr">
          <img src="@/assets/img/ma.jpg" alt="" />
          <div class="footer-main-ri-ri">
            <p>扫描二维码</p>
            <p>关注煤炭地质云</p>
            <p>精彩一手掌握</p>
          </div>
        </div>
         <div class="footer-main-right fr">
          <img src="@/assets/img/zdsys.png" alt="" />
          <div class="footer-main-ri-ri" style="margin-right: 20px;">
            <p>扫描二维码</p>
            <p>关注重点实验室</p>
            <p>精彩一手掌握</p>
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>
<script>
  import {
    getfootList
  } from '@/api/foot.js';
  export default {
    data() {
      return {
        tableData: []
      };
    },
    mounted()
    {
      this.GetFootData()
    },
    methods: {
      GetFootData() {
        getfootList().then((res) => {
          if (res.Code == 200) {
            this.tableData = res.Data;
          } else {
            this.tableData = [];
          }
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/layout/components/foot/foot.vue